/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPageHero from './components/IndexPageHero';
import { components } from '@fof-polls';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default function () {
	if (app.initializers.has('fof/polls')) {
		override(components.AbstractPollPage.prototype, 'hero', function () {
			const title = t('fof-polls.forum.polls_page.title');

			return <IndexPageHero title={title} />;
		});
	}
}
